import moment from 'moment';

export const DATE_OPTIONS_FOR_REPORTS = [
  {
    displayText: 'Today',
    range: [
      moment()
        .startOf('day')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Yesterday',
    range: [
      moment()
        .subtract(1, 'day')
        .startOf('day')
        .toDate(),
      moment()
        .subtract(1, 'day')
        .endOf('day')
        .toDate(),
    ],
  },
];

export const ALL_VENDORS = 'ALL_VENDORS';

export const SETTLEMENTS = 'SETTLEMENTS';

export const VENDOR_RECON = 'VENDOR_RECON';

export const DATE_FORMAT_FOR_FILE_NAME = 'DD MMM YYYY';

export const PAYMENT_LINK_TRANSACTIONS = 'PAYMENT_LINK_TRANSACTIONS';

export const TRANSACTIONS = 'TRANSACTIONS';

export const SETTLEMENTS_RECON = 'SETTLEMENTS_RECON';

export const FLOW_WISE_RECON = 'FLOW_WISE_RECON';

export const FLOW_WISE_RECON_VALUE = 'flow_wise_recon_report';

export const SUBSCRIPTION_PAYMENTS = 'SBC_PAYMENTS';

export const ALL_ORDERS = 'ALL_ORDERS';

export const VENDOR_ORDER_RECON = 'VENDOR_ORDER_RECON';

export const RISK_TRANSACTIONS = 'RISK_TRANSACTIONS';

export const VENDOR_RECON_REPORT_FILE_NAME = {
  [SETTLEMENTS]: 'Settlement Recon Report',
  [VENDOR_RECON]: 'Vendor Recon Report',
};

export const VENDOR_ORDER_RECON_REPORT_FILE_NAME = {
  [ALL_ORDERS]: 'Order Recon Report',
  [VENDOR_ORDER_RECON]: 'Vendor Order Recon Report',
};

export const VENDOR_RECON_REPORT_OPTIONS = [
  {
    key: ALL_VENDORS,
    text: 'All Vendors',
    description: 'View vendor reconciliation details of all vendors.',
    value: ALL_VENDORS,
  },
  {
    key: SETTLEMENTS,
    text: 'Settlements Specific',
    description:
      'View vendor reconciliation details that are specific to a settlement by specifying the settlement ID.',
    value: SETTLEMENTS,
  },
  {
    key: VENDOR_RECON,
    text: 'Vendor Specific',
    description:
      'View vendor reconciliation details specific to a vendor by specifying the vendor ID.',
    value: VENDOR_RECON,
  },
];

export const VENDOR_ORDER_RECON_REPORT_OPTIONS = [
  {
    key: ALL_ORDERS,
    text: 'All Orders',
    // description: 'View vendor reconciliation details of all vendors.',
    value: ALL_ORDERS,
  },
  {
    key: VENDOR_ORDER_RECON,
    text: 'Order Specific',
    description: '',
    // 'View vendor reconciliation details specific to a vendor by specifying the vendor ID.',
    value: VENDOR_ORDER_RECON,
  },
];

export const SBC_REPORT_OPTIONS = [
  {
    key: 'SBC_PAYMENTS',
    text: 'Subscription Payments',
    value: 'subscription_payments_datalake',
    fileName: 'Subscription Payments Report',
    description:
      'View payment details like Order ID, Status, Issuer Name and Order Date for the date range selected.',
  },
  {
    key: 'SUBSCRIPTIONS',
    text: 'Subscriptions',
    value: 'subscription',
    fileName: 'Subscriptions Report',
    description:
      'View subscription details like Subscription ID, Status, Customer Name and Subscription Date for the date range selected.',
  },
];

export const SELECT_ALL_STATUS = {
  key: 'select_all_status',
  value: 'SELECT_ALL_STATUS',
  label: 'Select all',
};

export const SELECT_ALL_SBC_PAYMENT_STATUS = {
  key: 'select_all_sbc_payment_status',
  value: 'SELECT_ALL_SBC_PAYMENT_STATUS',
  label: 'Select all',
};

export const SELECT_ALL_SBC_STATUS = {
  key: 'select_all_sbc_status',
  value: 'SELECT_ALL_SBC_STATUS',
  label: 'Select all',
};

export const SELECT_ALL_OTHER_FLAGS = {
  key: 'select_all_other_flags',
  value: 'SELECT_ALL_OTHER_FLAGS',
  label: 'Select all',
};

export const SELECT_ALL_GATEWAYS = {
  key: 'select_all_gateways',
  value: 'SELECT_ALL_GATEWAYS',
  label: 'Select all',
};
